import SEOArticlePage from "@/components/feature/SEOArticlePage";
import { articleContents } from "@/mocks/seo-article-content";

export default function HipobuyVsGoogleSheets() {
  return <SEOArticlePage article={articleContents["hipobuy-vs-google-sheets"]} />;
}